var map = {
	"./img_1.jpg": 21867,
	"./img_2.jpg": 70779,
	"./img_3.jpg": 46515,
	"./img_4.jpg": 23919,
	"./img_5.jpg": 11060,
	"./img_6.jpg": 17832,
	"./img_7.jpg": 80024,
	"./img_8.jpg": 43800
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30864;